import mergeConfig from 'coact/config/mergeConfig'

import clientConfig from './clientConfig.js'
import eventClientConfig from './eventClientConfig.js'

const config = {
  models: {
    retailOrders: {
      views: {
        cashier: clientConfig,
        eventCashier: eventClientConfig,
      },
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
